import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ToastService } from 'src/app/shared/services/toast.service';
import { PaisModel } from '../home/store/registro-usuario.store.model';
import { TipoDocumentoPaisModel, DatosEmail } from '../home/store/registro-usuario.store.model';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recuperar-clave',
  templateUrl: './recuperar-clave.component.html',
  styleUrls: ['./recuperar-clave.component.scss']
})
export class RecuperarClaveComponent implements OnInit {

  stepTipoRegistroL: string = "";
  stepClaveL: string = "";

  stepTipoRegistro: string = "";
  stepVerificacion: string = "";
  stepClave: string = "";

  isShowFin: boolean = true;
  isShowProceso: boolean = false;

  paises: PaisModel[];  
  selectedPais: number;

  tipoDocumentoPais: TipoDocumentoPaisModel[];
  selectedTipDocPais: number;

  datosEmail: DatosEmail;
  //visor de contraseñas
  isTypeP1bol = false; 
  isTypeP2bol = false; 

  //cambie el type de la contraseña
  isTypeP1 = null;
  isTypeP2 = null;

  caracteres: string;
  urlPortal: string;

  datosRegistro: {
    nroDocumento: string,
    razonSocial: string,
    correo1: string,
    correo2: string,
    clave: string,
    claveSeg: string,
    codigo: string,
    codigoSeg: string,
    cPais: string,
    cTipoDocumento: string,
    pPais: number,
    tipDoc: number,
    pk: number
  } = {
    nroDocumento: "",
    razonSocial: "",
    correo1: "",
    correo2: "",
    clave: "",
    claveSeg: "",
    codigo: "",
    codigoSeg: "",
    cPais: "",
    cTipoDocumento: "",
    pPais: 1,
    tipDoc: 1,
    pk: 0
  }

  constructor(
    private usuariosService: UsuariosService,
    private router: Router,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.stepTipoRegistroL = ""
    this.stepTipoRegistro = "active"
    //this.stepVerificacionL = ""
    //this.stepClaveL = ""
    this.isShowFin = true;
    this.isShowProceso = false;

    this.selectedPais = 0;
    this.selectedTipDocPais = 0;

    this.isTypeP1 = "password"
    this.isTypeP2 = "password"

    this.caracteres = ".$@¡!%*¿?&";
    this.urlPortal = environment.loingUrlPortal;

    this.listarPais();
    this.selectedPais = 104;
    this.listarTipoDocumentoPais(104);
    
  }

  listarPais = () => {
    this.usuariosService.listarPais(0).subscribe(data => this.paises = data.result
      //,error => console.log(error)
      );
  }

  handleChangePais(event) {
    this.listarTipoDocumentoPais(this.selectedPais);
  }

  listarTipoDocumentoPais = (idPais: number) => {
    this.selectedTipDocPais = 0;
    //jclr
    this.usuariosService.listarTipoDocumentoPais(idPais,1).subscribe(data => this.tipoDocumentoPais = data.result
      //,error => console.log(error)
      );
  }

  handleCerrar = () => {
    //this.router.navigate(['/login/']);
    location.href = environment.loingUrlPortal;
  }

  encriptarClave = (dato: string): string => {
    return CryptoJS.MD5(dato).toString();
  };

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberRandom = () =>{
      //const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
      const chars = '0123456789';
      const stringLength = 8;
      let randomstring = '';
      for (let i = 0; i < stringLength; i++) {
        const rnum = Math.floor(Math.random() * chars.length);
        randomstring += chars.substring(rnum, rnum + 1);
      }
      return randomstring;
  }

  handleVisorP = (type) => {
    switch (type) {
      case 1: this.isTypeP1bol = !this.isTypeP1bol;
              if(this.isTypeP1bol)
              {
                this.isTypeP1 = "text";
              }
              else
              {
                this.isTypeP1 = "password";
              }
              break;
        case 2: this.isTypeP2bol = !this.isTypeP2bol;
              if(this.isTypeP2bol)
              {
                this.isTypeP2 = "text";
              }
              else
              {
                this.isTypeP2 = "password";
              }
              break;
    }
  }

  enviarEmailCodigo = (login, prueba, cuerpo, flag) => {
    this.usuariosService.enviarEmailDatosUsuario(login, prueba,cuerpo, flag).subscribe(
          (data) => {
            //console.log(data) 
          },
        (error) => {
            //console.log(error)
        }
    );
  };

  handleChangeStepBack = (step) => {
    switch (step) {
      case 1: this.stepTipoRegistro = "active";
              this.stepClave = "";
              this.stepTipoRegistroL = "";
              this.stepClaveL = "";
              this.stepVerificacion = "";

              //limpiar datos ingresados
              this.datosRegistro.correo1 = "";
              this.datosRegistro.correo2 = "";
              this.datosRegistro.clave = "";
              this.datosRegistro.claveSeg = "";
              this.datosRegistro.razonSocial = "";
              this.datosRegistro.nroDocumento = "";
              this.datosRegistro.codigo = "";
              this.selectedPais = 0;
              this.selectedTipDocPais = 0;
              this.listarTipoDocumentoPais(0);
              break;

      case 2: this.stepTipoRegistro = ""; 
              this.stepClave = "";
              this.stepClaveL = "";
              this.stepVerificacion = "active";

              //limpiar datos ingresados
              this.datosRegistro.correo1 = "";
              this.datosRegistro.correo2 = "";
              this.datosRegistro.clave = "";
              this.datosRegistro.claveSeg = "";
              this.datosRegistro.razonSocial = "";
              this.datosRegistro.nroDocumento = "";
              this.datosRegistro.codigo = "";
              this.selectedPais = 0;
              this.selectedTipDocPais = 0;
              this.listarTipoDocumentoPais(0);
              break;
    }
  }

  handleChangeStep = (step) => {
    switch (step) {
      case 2: 
              if(this.selectedPais == 0){
                this.toast.error("Por favor selecciona el País");
                break;
              }
              if(this.selectedTipDocPais == 0){
                this.toast.error("Por favor selecciona el Tipo de Documento");
                break;
              }
              if(this.datosRegistro.nroDocumento == ""){
                this.toast.error("Por favor ingresa el número de documento");
                break;
              }
              let tipo
              if(this.selectedPais == 104){
                if(this.selectedTipDocPais == 120){
                 tipo = 1; 
                }
                else{
                  tipo = 2;
                }
              }
              else{
                tipo = 3;
              }
              this.datosRegistro.codigoSeg = this.numberRandom();
              this.usuariosService.validarRecuperar(tipo, this.selectedTipDocPais, this.selectedPais, this.datosRegistro.nroDocumento, this.encriptarClave(this.datosRegistro.codigoSeg)).subscribe((response) => {
                if(response.rptTipo == 0){                  
                  this.toast.error(response.rptMsg);
                }
                else{
                  this.datosRegistro.correo1 = response.uDesContacto;
                  this.datosRegistro.correo2 = response.uDesContacto;
                  var str = this.datosRegistro.correo2; 
                  var splitted = str.split("@", 2); 
                  var dato1 = splitted[0];
                  var dato2 = splitted[1];
                  dato1 = dato1.substring(0,1) + "***";
                  this.datosRegistro.correo2 = dato1 +"@"+ dato2;
                  this.datosRegistro.razonSocial = response.uNombreCompleto;
                  this.datosRegistro.cPais = response.cPais;
                  this.datosRegistro.cTipoDocumento = response.cTipoDocumento;
                  this.datosRegistro.pk = response.pK_eIdPersona;
                  
                  //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >PROVÍAS NACIONAL</span></div><br><div><span>Estimados : </span><b>"+this.datosRegistro.razonSocial+"</b></div></br><div><span>Para seguir con su solicitud, ingrese este código de verificación en la web.</span></div><br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>TU CÓDIGO DE VERIFICACIÓN ES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 100%;'><div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><span style='color:black;' ><b>"+this.datosRegistro.codigoSeg+"</b></span></div></div></div></div></div>";

                  //this.enviarEmailCodigo(this.datosRegistro.correo1, "Código verficación PROVÍAS",mensaje,true);
                  this.emailCodigo(this.datosRegistro.razonSocial,this.datosRegistro.codigoSeg,this.datosRegistro.correo1, "Código verficación PROVÍAS")

                  this.stepTipoRegistro = ""; 
                  this.stepVerificacion = "active";
                  this.stepClave = "";
                  this.stepTipoRegistroL = "active";
                }
              });
              break;
      case 3: if(this.datosRegistro.codigo == ""){
                this.toast.error("Por favor ingresa el código de verificación");
              }
              else if(this.datosRegistro.codigoSeg != this.datosRegistro.codigo){
                this.toast.error("Código de verificación inválido");
              }
              else {
                this.stepTipoRegistro = ""; 
                this.stepVerificacion = "";
                this.stepClave = "active";
                this.stepTipoRegistroL = "active";
                this.stepClaveL = "active";
              }
              break;
    }
  }

  finalizar = () => {
    if(this.datosRegistro.clave == "")
    {
      this.toast.error("Por favor ingresa contraseña");
    }
    else if(this.datosRegistro.claveSeg == "")
    {
      this.toast.error("Por favor repita la contraseña");
    }
    else if(this.datosRegistro.clave != this.datosRegistro.claveSeg)
    {
      this.toast.error("Por favor ingresa la misma contraseña");
    }
    else if(this.datosRegistro.clave.length < 8)
    {
      this.toast.error("Por favor la contraseña debe tener mínimo 8 caracteres");
    }
    else if(this.validarContraseña(this.datosRegistro.clave))
    {
      this.toast.error("Contraseña invalida");
    }
    else{
      this.isShowFin = !this.isShowFin;
      this.isShowProceso = ! this.isShowProceso;

      this.cambioClave();
    }
  }

  cambioClave = () =>  {
    this.usuariosService.cambioClave(this.datosRegistro.pk,1,this.encriptarClave(this.datosRegistro.clave),"").subscribe((response) => {
      if(response.rptTipo == 1){
        var tipMensaje = "";
        if(this.selectedPais == 104){
          if(this.selectedTipDocPais == 120){
            tipMensaje = "RUC";
          }
          else{
            tipMensaje = "DNI";
          }
        }
        else{
          tipMensaje = "Usuario";
        }
        //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DEL ADMINISTRADO DE PROVÍAS NACIONAL</span></div><div> <span>Estimados : </span><b>"+this.datosRegistro.razonSocial+" </b></br><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en línea</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'> <div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>"+ tipMensaje +": </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.nroDocumento+"</b></span></div></div><div style='float:left;width: 50%;'> <div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>Contraseña: </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div><span style='color:black;' ><b>ACCEDA AL PORTAL</b></span></br><span style='color:black;' ><a href='http://www.pvn.gob.pe'>www.pvn.gob.pe</a></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>IMPORTANTE</b></span></br> <span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo será bajo su responsabilidad</b></span> </div> </br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>CONTACTENOS</b></span><ul style='list-style: none '> <li>Central Telefónica 615-7800</li></ul></div>";
        //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</span></div><div><span>Estimados : </span><b>"+this.datosRegistro.razonSocial+"</b></div><div><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en línea.</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'><div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>"+ tipMensaje +"</b></span></div><div><span style='color:black;' ><b>"+this.datosRegistro.nroDocumento+"</b></span></div></div></div><div style='float:left;width: 50%;'><div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>Contraseña</b></span></div><div><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div></div><div><span style='color:black;' ><b>ACCEDA AL PORTAL EN </b></span></div><div><span style='color:black;' ><a href='"+environment.loingUrlPortal+"'>este enlace</a></span></div></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><div><span style='color:red;' ><b>IMPORTANTE</b></span></br></div><div><span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo será bajo su responsabilidad</b></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><div><span style='color:red;' ><b>CONTACTENOS</b></span></div><div><span align=center >Central Telefónica 615-7800</span></div></div>";

        //this.enviarEmailCodigo(this.datosRegistro.correo1, "Recuperar Clave Usuario PROVÍAS",mensaje,true);

        this.emailRegistro(tipMensaje,this.datosRegistro.nroDocumento,this.datosRegistro.razonSocial,"",this.datosRegistro.correo1,"Recuperar Clave Usuario PROVÍAS",this.datosRegistro.clave)
        
      }
    });
  }

  validarContraseña = (clave) => {
    let hasNumber = /\d/.test(clave);
    let hasUpper = /[A-Z]/.test(clave);
    let hasLower = /[a-z]/.test(clave);
    let hasSymbol = /[!#$%&'()*+,-./:;<=>?@\^_`{[]|}~.]/.test(clave);
    //let hasSymbol = /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/.test(clave);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = hasNumber && hasUpper && hasLower && hasSymbol;
    if (!valid) {
        // return what´s not valid
        return { strong: true };
    }
    return false;
  }

  encriptarClaveCorreo = (dato: string): string => { 
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
        var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(dato), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        return encrypted.toString();
  };

  emailRegistro(tipodoc, nrodoc, usuario, codigo, email, titulo, pass){
    this.datosEmail = {
      empresa: usuario,
      tipdoc: tipodoc,
      usuario: nrodoc,
      clave: pass,
      correo: email,
      link: environment.loingUrlPortal,
      codverifica: "",
      asunto: titulo
    }
    
    this.usuariosService.emailRegistro(this.datosEmail).subscribe(
        (data) => {
          //console.log(data) 
        },
      (error) => {
          //console.log(error)
      }
    )
  }

  emailCodigo(usuario, codigo, email, titulo){
    this.datosEmail = {
      empresa: usuario,
      tipdoc: "",
      usuario: "",
      clave: "",
      correo: email,
      link: environment.loingUrlPortal,
      codverifica: codigo,
      asunto: titulo
    }
    
    this.usuariosService.emailCodigo(this.datosEmail).subscribe(
        (data) => {
          //console.log(data) 
        },
      (error) => {
          //console.log(error)
      }
    )
  }
}
